import { Tabs, TabsList, TabsTrigger } from "@/shadcnComponents/ui/tabs";
import { Card, CardContent } from "@/shadcnComponents/ui/card";
import { Button } from "@/shadcnComponents/ui/button";
import { Coins, CreditCard, IndianRupee, Info, Wallet } from "lucide-react";
import { TabsContent } from "@radix-ui/react-tabs";
import MobileMenuBar from "../../../../Components/Menubar/MobileMenuBar";
import { useEffect } from "react";
import { DashboardTabTriggers } from "./earningWallet.utils";
import { WithdrawModal } from "./Components/components";
import Confetti from "react-confetti";
import mixpanel from "mixpanel-browser";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../../shadcnComponents/ui/tooltip";
import { InfluEarningWalletProvider } from "./State/earningWallet.hooks";
import { useInfluEarningWallet } from "./State/context";
import { ReferralEarning } from "./Components/ReferralEarning";
import { CollabEarning } from "./Components/CollabEarning";
// import { WithdrawRequest } from "./Components/WithdrawRequests";
import {
  ScrollArea,
  ScrollBar,
} from "../../../../shadcnComponents/ui/scroll-area";
import { useNavigate } from "react-router-dom";

export function EarningWallet() {
  return (
    <>
      <InfluEarningWalletProvider>
        <EarningDashBoard />
      </InfluEarningWalletProvider>
    </>
  );
}

export function EarningDashBoard() {
  const navigate = useNavigate();
  const {
    fetchEarnings,
    fetchReferrals,
    fetchCollabEarnings,
    // handleGetAllWithdrawRequest,
    showConfetti,
    modalOpen,
    earnings,
    setModalOpenState,
  } = useInfluEarningWallet();

  useEffect(() => {
    mixpanel.track("Influencer Visited Wallet Page");
    fetchEarnings();
    fetchReferrals();
    fetchCollabEarnings();
    // handleGetAllWithdrawRequest();
  }, []);

  return (
    <>
      {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          style={{ zIndex: 9999 }}
        />
      )}
      {modalOpen?.requestWithdrawal && (
        <WithdrawModal
          open={modalOpen?.requestWithdrawal}
          onOpenChange={(value) =>
            setModalOpenState("requestWithdrawal", value)
          }
          balance={earnings?.overall?.totalBalance}
        />
      )}
      <MobileMenuBar />
      <div className="bg-background-dark text-foreground-bright dark mb-[100px]">
        <main className="container flex flex-col gap-[30px] mx-auto px-4 py-12 md:px-6 lg:px-8">
          <div className="w-full max-w-6xl mx-auto flex flex-col gap-6">
            {/* Top Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ">
              {[
                {
                  title: "Overall Earnings",
                  value: `₹${earnings?.overall?.totalEarnings || 0}`,
                  icon: <Coins className="h-6 w-6 text-yellow-500" />,
                  renderCondition: true,
                },
                {
                  title: "Withdrawn Money",
                  value: `₹${earnings?.overall?.totalWithdrawn || 0}`,
                  icon: <Wallet className="h-6 w-6 text-green-500" />,
                  renderCondition: true,
                },
                {
                  title: "Balance Left",
                  value: `₹${earnings?.overall?.totalBalance || 0}`,
                  icon: <IndianRupee className="h-6 w-6 text-yellow-500" />,
                  renderCondition: true,
                },
              ]?.map((section, i) => {
                if (!section.renderCondition) return null;
                return (
                  <Card key={i} className="bg-[#212121] border-[#424242]">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="text-sm text-zinc-400">
                          {section?.title}
                        </p>
                        <p className="text-2xl font-bold text-white">
                          {section?.value}
                        </p>
                      </div>
                      {section?.icon}
                    </CardContent>
                  </Card>
                );
              })}
            </div>

            {/* Withdraw Button */}
            <div className="flex justify-end">
              <div className="flex items-center gap-2">
                {
                  <Button
                    onClick={() => {
                      navigate("/influencer/paymentDetails");
                    }}
                    className="bg-red-600 hover:bg-red-700 items-center text-white"
                  >
                    <CreditCard className="h-6 w-6 " />
                    Payment Details
                  </Button>
                }
                <Button
                  className="bg-red-600 hover:bg-red-700 text-white"
                  disabled={
                    earnings?.overall?.totalBalance <
                      earnings?.minWithdrawLimit ||
                    earnings?.pendingWithdrawRequest
                      ? true
                      : false
                  }
                  onClick={() => {
                    setModalOpenState("requestWithdrawal", true);
                  }}
                >
                  {earnings?.pendingWithdrawRequest
                    ? "Payout in process"
                    : "Withdraw Earnings"}
                </Button>
                {earnings?.overall?.totalBalance <
                  earnings?.minWithdrawLimit && (
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger>
                        <Info className="h-5 w-5 text-gray-400" />
                      </TooltipTrigger>
                      <TooltipContent>
                        <div className="text-[12px] leading-[20px]">
                          <p>
                            You can withdraw your earnings once it reaches ₹
                            {earnings?.minWithdrawLimit}.
                          </p>
                        </div>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
              </div>
            </div>

            {/* Divider */}
            <hr className="border-zinc-800" />

            {/* Tabs */}
            <Tabs defaultValue="referral" className="w-full space-y-4">
              <TabsList className="flex bg-[#212121] border-zinc-800 md:w-fit">
                <ScrollArea className="flex-grow overflow-x-auto">
                  <div className="flex flex-nowrap">
                    {[
                      {
                        title: "Referral Earning",
                        triggerValue: DashboardTabTriggers.REFERRAL,
                      },
                      {
                        title: "Collab Earning",
                        triggerValue: DashboardTabTriggers.COLLAB,
                      },
                      // {
                      //   title: "Withdraw Requests",
                      //   triggerValue: DashboardTabTriggers.WITHDRAW,
                      // },
                    ].map((tab, i) => {
                      return (
                        <TabsTrigger
                          key={i}
                          value={tab?.triggerValue}
                          className="text-[#757575] data-[state=active]:bg-[#171717] data-[state=active]:text-[#FAFAFA]"
                        >
                          {tab?.title}
                        </TabsTrigger>
                      );
                    })}
                  </div>
                  <ScrollBar orientation="horizontal" />
                </ScrollArea>
              </TabsList>
              <TabsContent value={DashboardTabTriggers.REFERRAL}>
                <ReferralEarning />
              </TabsContent>
              <TabsContent value={DashboardTabTriggers.COLLAB}>
                <CollabEarning />
              </TabsContent>
              {/* <TabsContent value={DashboardTabTriggers.WITHDRAW}>
                <WithdrawRequest />
              </TabsContent> */}
            </Tabs>
          </div>
        </main>
      </div>
    </>
  );
}
